import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { createOrganization, createDiscover, addOrganizationSettings } from "../../api/Organization";
import { failed, success } from "../../common/Toastify";
import CountrySelect from "../../common/textfield/CountrySelect";
import RegionSelect from "../../common/textfield/RegionSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import Select from "react-select";
import {
	devicesField,
	deviceUnitTypeOptions,
	filterKeysFunc,
	FormikObj,
	typeOfDeviceUnitTypeOptions,
	ORGANIZATION_DETAILS,
	NAME,
	DESCRIPTION,
	ADDRESS,
	COUNTRY,
	CITY,
	ZIP_CODE,
	POSTAL_CODE,
	PHONE_NUMBER,
	EXT,
	EMAIL_ADDRESS,
	APPOINTMENT_CANCEL_TIME,
	DEVICE_UNIT_TYPE,
	TYPE,
	CANCEL,
	CREATE,
	operationTiming,
	transformTimingData,
	getDeviceUnit,
	getValidationSchema
} from "./Constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import { Tooltip, Switch } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import TextArea from "../../common/textfield/TextArea";
import SelectFiled from "../../common/textfield/SelectFiled";
import { createContactNumber } from "../../../utils/phoneNumberSupport";
import InputFile from "../../common/textfield/InputFile";
import { useSelector } from "react-redux";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import { useMedia } from "react-use";
import { SurveySettings } from "./SurveySettings";
import GetCareSettings from "./GetCareSettings";
import { ProductFeatures } from "./ProductFeatures";
import { SFTSettings } from "./SFTSettings";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";
import './organization.css';
import OrganizationCard from "./OrganizationCard";
import { createServiceLine } from "../../api/ServiceLine";
import { InfoOutlined } from "@mui/icons-material";


function AddOrganization() {
	const navigate = useNavigate();
	const userOrgId = useSelector((state) => state?.auth?.user?.organizations?.[0]?.id);
	const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
	const [inputValue, setInputValue] = useState("");
	const [btnLoading, setBtnLoading] = useState(false)
	const [organizations, setOrganizations] = useState([]);
	const [country, setCountry] = useState('');
	const [region, setRegion] = useState('');
	const [selectedData, setSelectedData] = useState([]);
	const [firstParentSelected, setFirstParentSelected] = useState([]);
	const [parentInputsValue, setParentInputsValue] = useState([]);
	const [waitingRoomTimings, setWaitingRoomTimings] = useState(operationTiming);
	const [waitingRoomTimingsError, setWaitingRoomTimingsError] = useState(false);
	const [file, setFile] = useState();
	const isMobile = useMedia('(max-width: 768px)');
	const [selectedTab, setSelectedTab] = useState("Details");

	const [rpmSwitch, setRpmSwitch] = useState(false);
	const [virtualCareSwitch, setVirtualCareSwitch] = useState(false);
	const [callCenterSwitch, setCallCenterSwitch] = useState(false);
	const [waitingRoomSwitch, setWaitingRoomSwitch] = useState(false);
	const [ctiSwitch, setCtiSwitch] = useState(false);
	const { data: orgLicensedProducts } = useGetOrgLicensedProducts({})
	const [submitAction, setSubmitAction] = useState(null);

	// const [sftSwitch, setSftSwitch] = useState(false);
	const [delivertoIndividualSwitch, setDelivertoIndividualSwitch,] = useState(false);
	const [delivertoLocationSwitch, setDelivertoLocationSwitch] = useState(false);

	//patient demograpihics enforcement switches
	const [enforceHCNSwitch, setEnforceHCNSwitch] = useState(false);
	const [enforceEmailSwitch, setEnforceEmailSwitch] = useState(false);
	const [enforcePhoneNumberSwitch, setEnforcePhoneNumberSwitch] = useState(false);
	const [enforceAddressSwitch, setEnforceAddressSwitch] = useState(false);
	const [enforceCountrySwitch, setEnforceCountrySwitch] = useState(false);
	const [enforceProvinceSwitch, setEnforceProvinceSwitch] = useState(false);
	const [enforceCitySwitch, setEnforceCitySwitch] = useState(false);
	const [enforcePostalCodeSwitch, setEnforcePostalCodeSwitch] = useState(false);
	const [enforceDOBSwitch, setEnforceDOBSwitch] = useState(false);
	const [enforceGenderSwitch, setEnforceGenderSwitch] = useState(false);
	const [enforceFirstNameSwitch, setEnforceFirstNameSwitch] = useState(false);
	const [enforceLastNameSwitch, setEnforceLastNameSwitch] = useState(false);

	const [enforcePractitionerDOB, setEnforcePractitionerDOB] = useState(false);
	const [enforcePractitionerGender, setEnforcePractitionerGender] = useState(false);
	const [enforcePractitionerAddress, setEnforcePractitionerAddress] = useState(false);
	const [enforcePractitionerCountry, setEnforcePractitionerCountry] = useState(false);
	const [enforcePractitionerProvince, setEnforcePractitionerProvince] = useState(false);
	const [enforcePractitionerCity, setEnforcePractitionerCity] = useState(false);
	const [enforcePractitionerPostal, setEnforcePractitionerPostal] = useState(false);
	const [ecrEnabled, setEcrEnabled] = useState(false);



	const onSuccessOrg = (data) => {
		setOrganizations(data?.map((org) => ({ ...org, label: org?.name, value: org?.id })))
	};
	useOrgQuery({ onSuccess: onSuccessOrg });

	const formik = useFormik({
		...FormikObj,
		validationSchema: () => getValidationSchema(selectedTab),
		onSubmit: async (values) => {
			values.name = values.name?.trim();
			values.description = values.description?.trim();
			values.address = values.address?.trim();
			values.city = values.city?.trim();
			values.country = values.country?.trim();
			values.region = values.region?.trim();
			values.postalCode = values.postalCode?.trim();
			values.phone_number = values.phone_number?.trim();
			values.email = values.email?.trim();
			values.privacyStatement = values.privacyStatement?.trim();
			values.supportStatement = values.supportStatement?.trim();
			if (submitAction === 'save') {
				const isHoursOfOperationFalse = !!values.isWaitingRoom && !!!values.hoursOfOperation
				let hasValues = Object.values(waitingRoomTimings).some(value => value?.startTime || value?.endTime)
				if (isHoursOfOperationFalse && !hasValues) {
					setWaitingRoomTimingsError(true)
				} else {
					setWaitingRoomTimingsError(false)
					setBtnLoading(true);
					let base64OrgLogo = "";
					if (values?.orgLogoURL) {
						base64OrgLogo = await handleFileUpload(values?.orgLogoURL);
					}
					const fileExtension = values?.orgLogoURL?.type?.split("/")[1];
					const orgLogoURL = {
						data: base64OrgLogo,
						extension: fileExtension // Add the file extension to the object
					};
					const deviceUnit = getDeviceUnit(values);
					if (values.typeOfDeviceUnitType === "group")
						deviceUnit["groupName"] = values.deviceUnitType;
					const parentOrg = values.organization;
					values.phone_number = createContactNumber(values)
					let sft = values.sftEnabled
						? {
							"enabled": values.sftEnabled,
							"individualDelivery": delivertoIndividualSwitch,
							"locationDelivery": delivertoLocationSwitch,
							"expirationDays": values.expirationDays,
							"privacyStatement": values.privacyStatement,
							"supportStatement": values.supportStatement
						}
						: {
							"enabled": values.sftEnabled,
							// "privacyStatement": values.privacyStatement,
							// "supportStatement": values.supportStatement
						};

					let triageSettings = {
						initialAssessmentQuestion: values?.initialAssessmentQuestion
					}


					let appointmentAutoAcceptance = {
						"patientInitiated": values?.patientApptAutoAcceptance, //(via the Mobile App) 
						"practitionerInitiated": values?.practitionerApptAutoAcceptance //(via the Web UI) 
					}

					createOrganization(values, parentOrg, deviceUnit, orgLogoURL, isHoursOfOperationFalse ? transformTimingData(waitingRoomTimings) : null, sft, appointmentAutoAcceptance, triageSettings)
						.then((res) => {
							const requestBody = {
								licensedProduct: {
									"RPM": rpmSwitch,
									"virtualCare": virtualCareSwitch,
									"callCenter": callCenterSwitch
								},
								//sft: Checksft,
								orgId: res.data.id,
							};
							let orgIdToPopulate = res?.data?.id;
							createDiscover(requestBody).then((res) => {
								// navigate("/app/manage-organization");
								// success(res.message);
								let payloadForDefaultServiceLine = {
									name: "Default Service Line",
									description: "Default Service Line for organization",
									orgId: orgIdToPopulate,
									isDefault: true
								}
								createServiceLine(orgIdToPopulate, payloadForDefaultServiceLine)
							}).catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
								.finally(() => setBtnLoading(false));


							const settingsPayload = {
								"patient": {
									"hcn": enforceHCNSwitch,
									"email": enforceEmailSwitch,
									"phone": enforcePhoneNumberSwitch,
									"address": enforceAddressSwitch,
									"country": enforceCountrySwitch,
									"province": enforceProvinceSwitch,
									"city": enforceCitySwitch,
									"postalCode": enforcePostalCodeSwitch,
									"dob": enforceDOBSwitch,
									"gender": enforceGenderSwitch,
									"firstName": enforceFirstNameSwitch,
									"lastName": enforceLastNameSwitch
								},
								"practitioner": {
									"dob": enforcePractitionerDOB,
									"gender": enforcePractitionerGender,
									"address": enforcePractitionerAddress,
									"country": enforcePractitionerCountry,
									"province": enforcePractitionerProvince,
									"city": enforcePractitionerCity,
									"postalCode": enforcePractitionerPostal
								},
								ecrEnabled: ecrEnabled,
								ecrIdentifier: values?.ecrIdentifier,
								encounterReportPrivacyStatement: values?.encounterReportPrivacyStatement,
								faxCoverPrivacyStatement: values?.faxCoverPrivacyStatement

							};

							addOrganizationSettings(res?.data?.id, {
								settings: settingsPayload
							}).then((res) => {
								success(res.message);
							}).catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message));

							navigate("/app/manage-organization");
							success(res.message);
						})
						.catch((res) => {
							failed(
								res?.response?.data?.message ||
								res?.response?.data?.error ||
								res.message
							);
						})
						.finally(() => setBtnLoading(false));
				}
			}
		},
	});

	useEffect(() => {
		if (formik.values.hoursOfOperation) {
			setWaitingRoomTimingsError(false);
		}
	}, [formik.values.hoursOfOperation]);

	useEffect(() => {
		if (waitingRoomTimings && Object.values(waitingRoomTimings).some(value => value?.startTime || value?.endTime)) {
			setWaitingRoomTimingsError(false);
		}
	}, [waitingRoomTimings]);

	const handleUpdate = (selectedId, parentId, index) => {
		let selected = selectedData;
		if (selectedId) {
			selected[index + 1] = selectedId;
			selected = selected.slice(0, index + 2);
			setSelectedData(selected);
			setParentInputsValue(
				filterKeysFunc(parentId, selectedId, parentInputsValue, selectedData)
			);
		} else if (selectedData.length > index + 1) {
			selected = selected.slice(0, index + 1);
			setSelectedData(selected);
			setParentInputsValue(
				filterKeysFunc(parentId, "", parentInputsValue, selectedData)
			);
		}
	};
	const handleOrgChange = (selectedOption) => {
		console.log(selectedOption)
		setFirstParentSelected(selectedOption); // Update your local state
		setSelectedData(selectedOption ? [selectedOption] : []); // Handle an empty array for a cleared selection
		formik.setFieldValue("organization", selectedOption); // Correctly update Formik's state
	};

	const handleUnitOfDeviceChange = (key, value) => {
		formik.setFieldValue(key, value);
	};

	const handleTimeChange = (day, value, key) => {
		key === "startTime"
			? setWaitingRoomTimings({ ...waitingRoomTimings, [day]: { startTime: value, endTime: null } })
			: setWaitingRoomTimings({ ...waitingRoomTimings, [day]: { ...waitingRoomTimings[day], [key]: value } });
	};


	const handleCountryChange = (newCountry) => {
		setCountry(newCountry);
		if (newCountry !== formik.values.country) {
			formik.setFieldValue("state", ""); // Reset Formik state only if the country is changing
			formik.setFieldValue("postalCode", "");
			formik.setFieldValue("city", "");
			setRegion(""); // Reset component state only if the country is changing
			setInputValue("")
		}
	};
	const handlePostalCodeChange = (e) => {
		const { value } = e.target;
		// Remove spaces and non-alphanumeric characters
		const formattedValue = value.replace(/[^A-Za-z0-9]/g, "");
		// Add a space after every 3 letters
		const spacedValue = formattedValue.replace(
			/^([A-Za-z0-9]{3})([A-Za-z0-9]+)/,
			"$1 $2"
		);
		// Set the formatted value in the state or formik
		setInputValue(spacedValue);
		formik?.setFieldValue("postalCode", spacedValue);
	};

	const handleSwitchChange = (setter) => {
		setter((prevValue) => !prevValue);
	};
	const handleCTISwitchChange = () => {
		setCtiSwitch((prev) => {
			const newValue = !prev;
			if (!newValue) {
				formik.setFieldValue("dni", [""]); // Reset dni when toggled off
			}
			if (newValue) {
				formik.setFieldValue("isCtiEnabled", true)
			} else {
				formik.setFieldValue("isCtiEnabled", false)
			}
			return newValue;
		});
	};
	// let margLeft =  formik.values.sftEnabled ? { marginLeft: '1px', marginRight: '-655px' } :  { marginLeft: '1px', marginRight: '-810px' } ;

	const handleSFTToggle = (event) => {
		formik?.setFieldValue("sftEnabled", event.target.checked);
	}

	const handleApptAcceptance = (event, type) => {
		if (type === "patientApptAutoAcceptance") {
			formik?.setFieldValue("patientApptAutoAcceptance", event.target.checked);
		} else if (type === "practitionerApptAutoAcceptance") {
			formik?.setFieldValue("practitionerApptAutoAcceptance", event.target.checked);
		}
	}

	/* Tabs */
	let tabTitles = [];
	if (userRoles?.includes('Super-Admin')) {
		tabTitles = ["Details", "Products", "Settings", "Privacy Statements", "Client Registry"];
		if(virtualCareSwitch) {
			tabTitles.push("Virtual Visit");
		}
		if(waitingRoomSwitch) {
      		tabTitles.push("Waiting Room");
    	}
		if (virtualCareSwitch || callCenterSwitch) {
			tabTitles.push("File Transfer");
		}
		if (rpmSwitch) {
			tabTitles.push("RPM");
		}
		if (callCenterSwitch) {
			tabTitles.push("Contact Center")
		}
		if (ctiSwitch && callCenterSwitch) {
			tabTitles.push("Telephony");
		}

	}
	const tabs = tabTitles.map(title => ({
		id: title,
		title: title,
		onClick: () => {
			if (selectedTab === "Virtual Visit") {
				formik.validateForm().then(errors => {
					let isHoursOfOperationFalse = !!formik.values.isWaitingRoom && !!!formik.values.hoursOfOperation;
					let hasValues = Object.values(waitingRoomTimings).some(value => value?.startTime || value?.endTime)
					if (Object.keys(errors).length === 0 && !isHoursOfOperationFalse && hasValues) {
						setSelectedTab(title);
						setWaitingRoomTimingsError(false);
					} else {
						if (isHoursOfOperationFalse && !hasValues) {
							setWaitingRoomTimingsError(true);
						} else {
							setWaitingRoomTimingsError(false);
							if (Object.keys(errors).length === 0) {
								setSelectedTab(title);
							}
						}
					}
				});
			} else {
				formik.validateForm().then(errors => {
					if (Object.keys(errors).length === 0) {
						setSelectedTab(title);
					}
				});
			}
		},
		selected: selectedTab === title
	}));

	/* Previous button */
	const handlePrevious = () => {
		const currentIndex = tabTitles.indexOf(selectedTab);
		const previousTab = tabTitles[currentIndex - 1];
		setSelectedTab(previousTab);
	};

	/* Next button */
	const handleNext = () => {
		if (selectedTab === "Virtual Visit") {
			formik.validateForm().then(errors => {
				let isHoursOfOperationFalse = !!formik.values.isWaitingRoom && !!!formik.values.hoursOfOperation;
				let hasValues = Object.values(waitingRoomTimings).some(value => value?.startTime || value?.endTime)
				if (Object.keys(errors).length === 0 && !isHoursOfOperationFalse && hasValues) {
					const currentIndex = tabTitles.indexOf(selectedTab);
					const nextTab = tabTitles[currentIndex + 1];
					setSelectedTab(nextTab);
					setWaitingRoomTimingsError(false);
				} else {
					if (isHoursOfOperationFalse && !hasValues) {
						setWaitingRoomTimingsError(true);
					} else {
						setWaitingRoomTimingsError(false);
						if (Object.keys(errors).length === 0) {
							const currentIndex = tabTitles.indexOf(selectedTab);
							const nextTab = tabTitles[currentIndex + 1];
							setSelectedTab(nextTab);
						}
					}
				}
			});
		} else {
			formik.validateForm().then(errors => {
				if (Object.keys(errors).length === 0) {
					const currentIndex = tabTitles.indexOf(selectedTab);
					const nextTab = tabTitles[currentIndex + 1];
					setSelectedTab(nextTab);
				}
			});
		}
	};
	const handleExt = (event) => {
		let key = event.key;
		let regex = new RegExp("^[0-9]+$");
		if (!regex.test(key)) {
			event.preventDefault();
			return false;
		}
	};
	const handleAddDNIRow = () => {
		let existingValues = formik?.values?.dni;
		let newValues = [...existingValues, ""];
		formik.setFieldValue("dni", newValues);
	}
	const handleRemoveDNI = (index) => {
		const existingValues = formik?.values?.dni || [];
		const newValues = existingValues.filter((_, i) => i !== index);
		formik.setFieldValue("dni", newValues);
	};
	const handleIAQToggle = (event) => {
		formik?.setFieldValue("initialAssessmentQuestion", event.target.checked);
	};

	const handleOrgActiveToggle = (event) => {
		formik?.setFieldValue("active", event.target.checked);
	};
	const anyFeatureEnabled = virtualCareSwitch || callCenterSwitch || rpmSwitch || ctiSwitch || waitingRoomSwitch;
	const isLastTab = selectedTab === tabTitles[tabTitles.length - 1];
	return (
		<section className="common-listing">
			<div className="heading-wrap mb-3">
				<Tooltip title="Go back">
					<div
						style={{ marginRight: "1rem", cursor: "pointer" }}
						onClick={() => navigate(-1)}
					>
						<ArrowBack />
					</div>
				</Tooltip>
				<h1>{ORGANIZATION_DETAILS}</h1>
			</div>
			<div className="custom-card p-4 add-org-wrap">
				<form
					className="common-form border-fields"
					onSubmit={formik.handleSubmit}
				>
					<Row>
						{tabs.map(tab => (
							<Col key={tab.id} sm={4} md={3} lg={2} className="mb-3 mb-lg-0" onClick={tab.onClick}>
								<OrganizationCard title={tab.title} selected={tab.selected} />
							</Col>
						))}
					</Row><br />

					{/* Details start */}
					<div style={{ display: selectedTab === "Details" ? 'block' : 'none' }}>
						<Row>
							<Col md={8} lg={4}>
								<div className="field-wrap">
									<label >Select Parent Organization (Optional)</label>
									<Select
										keyField={"organization"}
										selectLabel="Select"
										formik={formik}
										options={organizations}
										isLoading={organizations?.length > 1 ? false : true}
										readOnly={organizations?.length > 1 ? false : true}
										hideRequired={true}
										onChange={handleOrgChange}
										onBlur={formik.handleBlur}
										className="search-select"
										classNamePrefix="select"
										isClearable={true}
									/>
								</div>
							</Col>
						</Row>
						<Row>
							<Col md={8} lg={4}>
								<TextInput
									keyField={"name"}
									label={NAME}
									formik={formik}
									placeholder={NAME}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								<TextArea
									keyField={"description"}
									required={false}
									label={DESCRIPTION}
									formik={formik}
									placeholder={DESCRIPTION}
								/>
							</Col>
							<Col></Col>
						</Row>
						<Row>
							<Col>
								<TextInput
									keyField={"address"}
									label={ADDRESS}
									formik={formik}
									placeholder={ADDRESS}
								/>
							</Col>
							<Col> </Col>
						</Row>
						<Row>
							<Col>
								<CountrySelect
									country={country}
									setCountry={handleCountryChange}
									keyField={"country"}
									label={COUNTRY}
									required
									formik={formik}
								/>
							</Col>
							<Col>
								<RegionSelect
									country={country}
									setRegion={setRegion}
									region={region}
									keyField={"state"}
									defaultOptionLabel={
										formik?.values?.country === "US"
											? "Select State"
											: "Select Province"
									}
									label={formik?.values?.country === "US" ? "State" : "Province"}
									required
									formik={formik}
								/>
							</Col>
							<Col>
								<TextInput
									keyField={"city"}
									label={CITY}
									formik={formik}
									placeholder={CITY}
								/>
							</Col>
							<Col>
								{formik?.values?.country === "US" ? (
									<TextInput
										keyField={"postalCode"}
										label={
											formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
										}
										formik={formik}
										placeholder={
											formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
										}
										// max length for both zip code and postal code(plus space)
										maxLength={formik?.values?.country === "US" ? "5" : "7"}
									/>
								) : (
									<TextInput
										onChange={handlePostalCodeChange}
										value={inputValue}
										keyField={"postalCode"}
										label={
											formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
										}
										formik={formik}
										placeholder={
											formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
										}
										// max length for both zip code and postal code(plus space)
										maxLength={formik?.values?.country === "US" ? "5" : "7"}
									/>
								)}
							</Col>
						</Row>
						<Row>
							<Col>
								<TextInput
									keyField={"phone_number"}
									type="phone"
									label={PHONE_NUMBER}
									formik={formik}
									placeholder={PHONE_NUMBER}
								/>
							</Col>
							<Col>
								{/* <TextInput
								keyField={"ext"}
								type="ext"
								label={EXT}
								formik={formik}
								placeholder={EXT}
								required={false}
							/> */}
								<TextInput
									keyField={"ext"}
									label={"Ext."}
									type="text"
									maxlength="4"
									formik={formik}
									placeholder={"Ext."}
									required={false}
									onKeyPress={handleExt}
									autocomplete="off"
								/>
							</Col>
							<Col>
								<TextInput
									keyField={"email"}
									label={EMAIL_ADDRESS}
									formik={formik}
									placeholder={EMAIL_ADDRESS}
								/>
							</Col>
						</Row>
						<Row>
							<Col style={{ maxWidth: "300px" }}>
								<InputFile accept="image/jpeg, image/png" keyField={"orgLogoURL"} label={"Upload Logo"} formik={formik} placeholder={"Upload Logo"} setFile={setFile} file={file} />
							</Col>
						</Row>
					</div>
					{/* Details End */}

					{/* Privacy Statements Tab */}
					<div style={{ display: selectedTab === "Privacy Statements" ? 'block' : 'none'}}>
						<Row>
							<Col>
								<TextArea
									keyField={"encounterReportPrivacyStatement"}
									required={true}
									label={"Encounter Report Privacy Statement"}
									formik={formik}
									placeholder={"Type here..."}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								<TextArea
									keyField={"faxCoverPrivacyStatement"}
									required={true}
									label={"Fax Cover Letter Privacy Statement"}
									formik={formik}
									placeholder={"Type here..."}
								/>
							</Col>
						</Row>
					</div>


					{/* RPM start */}
					<div style={{ display: selectedTab === "RPM" ? 'block' : 'none' }}>
						<Row>
							<Col>
								<SelectFiled
									keyField={"typeOfDeviceUnitType"}
									label={DEVICE_UNIT_TYPE}
									formik={formik}
									options={typeOfDeviceUnitTypeOptions}
									onChange={(e) =>
										formik.setFieldValue("typeOfDeviceUnitType", e.target.value)
									}
								/>
							</Col>
							<Col>
								{formik.values.typeOfDeviceUnitType === "group" ? (
									<SelectFiled
										keyField={"deviceUnitType"}
										label={TYPE}
										formik={formik}
										options={deviceUnitTypeOptions}
										onChange={(e) =>
											formik.setFieldValue("deviceUnitType", e.target.value)
										}
									/>
								) : null}
							</Col>
						</Row>
						{formik.values.typeOfDeviceUnitType === "individual" ? (
							<Row>
								{devicesField.map((field) => (
									<Col key={field.formikKey}>
										<SelectFiled
											keyField={field.formikKey}
											label={field.name}
											formik={formik}
											options={field.options}
											onChange={(e) =>
												handleUnitOfDeviceChange(field.formikKey, e.target.value)
											}
										/>
									</Col>
								))}
							</Row>
						) : null}
					</div>
					{/* RPM End */}

					{/* Virtual visit start */}
					<div style={{ display: selectedTab === "Virtual Visit" ? 'block' : 'none' }}>
						{userRoles?.includes('Super-Admin') || (userRoles?.includes('Practitioner') && orgLicensedProducts.virtualCare === true) ? <>
							{/* <GetCareSettings 
								formik={formik} 
								waitingRoomTimings={waitingRoomTimings} 
								waitingRoomTimingsError={waitingRoomTimingsError} 
								isMobile={isMobile} 
								handleTimeChange={handleTimeChange} />
							<hr /> */}
							<SurveySettings formik={formik} />
							<hr />	</> : null}
						{userRoles?.includes('Super-Admin') || userRoles?.includes('Practitioner') ?
							<>
								<Row>
									<Col><h5 style={{ color: "rgba(18, 31, 72, 1)" }}>Appointment Settings</h5></Col>
								</Row>
								<Row>
									<Col>
										<span >Auto Acceptance - Patient Initiated</span>
										<span style={{ marginRight: '135px' }}>&nbsp;&nbsp;</span>
										<Switch name="patientApptAutoAcceptance" onChange={(e) => handleApptAcceptance(e, "patientApptAutoAcceptance")} />
									</Col>
								</Row>
								<Row>
									<Col>
										<span >Auto Acceptance - Practitioner Initiated</span>
										<span style={{ marginRight: '100px' }}>&nbsp;&nbsp;</span>
										<Switch name="practitionerApptAutoAcceptance" onChange={(e) => handleApptAcceptance(e, "practitionerApptAutoAcceptance")} />
									</Col>
								</Row>
								<hr />
								<Row>
									<Col>
										<TextInput
											keyField={"appointment_cancel_time"}
											label={APPOINTMENT_CANCEL_TIME}
											formik={formik}
										/>
									</Col>
								</Row>
							</> : null}
					</div>
					{/* Virtual visit end */}
					{/* Waiting Room start */}
					<div
						style={{
							display: selectedTab === "Waiting Room" ? "block" : "none",
						}}
					>
					{userRoles?.includes("Super-Admin") ||
					userRoles?.includes("Practitioner") ? (
						<>
							<GetCareSettings
								formik={formik}
								waitingRoomTimings={waitingRoomTimings}
								waitingRoomTimingsError={waitingRoomTimingsError}
								isMobile={isMobile}
								handleTimeChange={handleTimeChange}
							/>    
						</>
					) : null}
					</div>
					{/* Waiting Room end */}
					{/* File Transfer start */}
					<div style={{ display: selectedTab === "File Transfer" ? 'block' : 'none' }}>
						<Row>
							<Col><h5 style={{ color: "rgba(18, 31, 72, 1)" }}>SFT Settings</h5></Col>
						</Row>

						<Row>
							<Col style={{ display: "flex", alignItems: "center", gap: "185px" }}>SFT
								<Switch name="sftEnabled" onChange={handleSFTToggle} />
							</Col>
						</Row>
						{formik.values.sftEnabled ?
							<>
								<SFTSettings
									delivertoIndividualSwitch={delivertoIndividualSwitch}
									delivertoLocationSwitch={delivertoLocationSwitch}
									onDeliverToIndSwitchChange={() => handleSwitchChange(setDelivertoIndividualSwitch)}
									onDeliverToLocSwitchChange={() => handleSwitchChange(setDelivertoLocationSwitch)}
								/>
								<Row>
									<Col>
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<span>Expiration Days </span> <span style={{ color: "red" }}>*</span>
											<span style={{ marginRight: '85px' }}>&nbsp;&nbsp;</span>
											<Tooltip title="Expiration days must be between 1 to 7">
												<div className="expiration-days-input">
													<TextInput
														keyField={"expirationDays"}
														required={formik.values.sftEnabled ? true : false}
														formik={formik}

													/>
												</div>
											</Tooltip>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<TextArea
											keyField={"privacyStatement"}
											required={formik.values.sftEnabled ? true : false}
											label={'Privacy Statement'}
											formik={formik}
										/>
									</Col>
									<Col></Col>
								</Row>
								<Row>
									<Col>
										<TextArea
											keyField={"supportStatement"}
											required={formik.values.sftEnabled ? true : false}
											label={'Technical Support Statement'}
											formik={formik}
										/>
									</Col>
									<Col></Col>
								</Row>
							</> : null}
					</div>
					{/* File Transfer end */}

					{/* Products start */}
					{userRoles?.includes('Super-Admin') && (
						<div style={{ display: selectedTab === "Products" ? 'block' : 'none' }}>
							{userRoles?.includes('Super-Admin') ? <>
								<ProductFeatures
									rpmSwitch={rpmSwitch}
									virtualCareSwitch={virtualCareSwitch}
									waitingRoomSwitch={waitingRoomSwitch}
				  					callCenterSwitch={callCenterSwitch}
									onRpmSwitchChange={() => handleSwitchChange(setRpmSwitch)}
									onVirtualCareSwitchChange={() => handleSwitchChange(setVirtualCareSwitch)}
									onWaitingRoomSwitchChange={() => handleSwitchChange(setWaitingRoomSwitch)}
									onCallCenterSwitchChange={() => handleSwitchChange(setCallCenterSwitch)}
								/>
							</> : null}
							<hr />

							{/* Organization Active/Inactive */}
							{userRoles?.includes("Super-Admin") ? (
								<>
									<Row>
										<Col>
											<h5 style={{ color: "rgba(18, 31, 72, 1)" }}>
												{" "}
												Organization Active/Inactive Settings
											</h5>
										</Col>
									</Row>
									<Row>
										<Col>
											<span>Active or Inactive </span>
											<span style={{ marginRight: "175px" }}>&nbsp;&nbsp;</span>
											<Switch
												name="active"
												onChange={handleOrgActiveToggle}
												defaultChecked={true}
											/>
										</Col>
									</Row>
									<hr />{" "}
								</>
							) : null}
							{!formik.values.active ? (
								<>
									<div class="alert alert-warning" role="alert">
										Attention: Disabling organization will suspend access for all
										users for this organization, including practitioners, until it
										is enabled again.
									</div>
								</>
							) : null}

							{userRoles?.includes("Super-Admin") && callCenterSwitch ? (
								<>
									<Row>
										<Col>
											<h5 style={{ color: "rgba(18, 31, 72, 1)" }}>
												{" "}
												Computer Telephony Integration (CTI)
											</h5>
										</Col>
									</Row>

									<Row>
										<Col>
											<span>Active or Inactive </span>
											<span style={{ marginRight: "175px" }}>&nbsp;&nbsp;</span>
											<Switch
												name="active"
												onChange={handleCTISwitchChange}
												defaultChecked={ctiSwitch}
											/>
										</Col>
									</Row>
								</>
							) : null}
						</div>
					)}
					{/* Products end */}

					{/* Triage Settings */}
					<div
						style={{
							display: selectedTab === "Contact Center" ? "block" : "none",
						}}
					>
						<Row>
							<Col>
								<h5 style={{ color: "rgba(18, 31, 72, 1)", marginTop: "20px" }}>Triage Settings (Protocol)</h5>
							</Col>
						</Row>
						<Row>
							<Col>
								<span style={{ marginLeft: '10px', marginRight: '8px' }}>Initial Assessment Question</span>
								<span style={{ marginRight: '88px' }}>&nbsp;&nbsp;</span>
								<Switch
									name="initialAssessmentQuestion"
									onChange={handleIAQToggle}
									defaultChecked={true}
								/>
							</Col>
						</Row>
					</div>

					{/* Telephony Setting start */}
					<div style={{ display: selectedTab === "Telephony" ? 'block' : 'none' }}>
						<div>
							<span>Add DNI numbers related to this organization</span>
							<hr />
						</div>
						{formik?.values?.dni?.map((phoneNumber, index) => {
							return (
								<Row>

									<Col style={{ marginTop: "20px" }}>
										<TextInput
											keyField={`dni[${index}]`}
											label={"Phone Number"}
											formik={formik}
											placeholder={"Phone Number"}
											tooltip={"Phone Numbers can only be created at Org level. These can be assigned to service lines"}
											required={false}
											hideRequired={true}

										/>
									</Col>
									<Col style={{ marginTop: "20px" }}>
										<DeleteIcon
											onClick={() => handleRemoveDNI(index)}
											style={{
												cursor: "pointer",
												color: "#c00",
												marginTop: "40px"
											}}
											titleAccess="Remove"
										/>
									</Col>
								</Row>
							)
						})}
						<Button onClick={handleAddDNIRow} variant="primary" style={{ marginTop: "20px" }}>+ Add DNI</Button>
						<hr />
					</div>

					{userRoles?.includes('Super-Admin') && (
						<div style={{ display: selectedTab === "Settings" ? 'block' : 'none' }}>
							<div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
								<label style={{ fontWeight: "bold", fontSize: "20px" }}>Patient Demographics Settings:</label>
								<div style={{ marginTop: "20px", marginLeft: "20px", display: "flex", flexDirection: "row", gap: "100px" }}>
									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient HCN:</label>
											<Switch
												name="enforceHCN"
												onChange={() => handleSwitchChange(setEnforceHCNSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, HCN will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient Email:</label>
											<Switch
												name="enforceEmail"
												onChange={() => handleSwitchChange(setEnforceEmailSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, email will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient Phone:</label>
											<Switch
												name="enforcePhone"
												onChange={() => handleSwitchChange(setEnforcePhoneNumberSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, phone number will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>

									</div>
									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Country:</label>
											<Switch
												name="enforceCountry"
												onChange={() => handleSwitchChange(setEnforceCountrySwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, country will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Province:</label>
											<Switch
												name="enforceProvince"
												onChange={() => handleSwitchChange(setEnforceProvinceSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, province will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>City:</label>
											<Switch
												name="enforceCity"
												onChange={() => handleSwitchChange(setEnforceCitySwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, city will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
									</div>

									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient First Name:</label>
											<Switch
												name="enforceFirstName"
												onChange={() => handleSwitchChange(setEnforceFirstNameSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, first name will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient Last Name:</label>
											<Switch
												name="enforceLastName"
												onChange={() => handleSwitchChange(setEnforceLastNameSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, last name will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Gender:</label>
											<Switch
												name="enforceGender"
												onChange={() => handleSwitchChange(setEnforceGenderSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, gender will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
									</div>

									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient DOB:</label>
											<Switch
												name="enforceDob"
												onChange={() => handleSwitchChange(setEnforceDOBSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, date of birth will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Postal Code:</label>
											<Switch
												name="enforcePostalCode"
												onChange={() => handleSwitchChange(setEnforcePostalCodeSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, postal code will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Patient Address:</label>
											<Switch
												name="enforceAddress"
												onChange={() => handleSwitchChange(setEnforceAddressSwitch)}
												defaultChecked={false}
											/>
											<Tooltip title="If enabled, address will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>

									</div>

								</div>
							</div>
							<div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
								<label style={{ fontWeight: "bold", fontSize: "20px" }}>Practitioner Demographics Settings:</label>
								<div style={{ marginTop: "20px", marginLeft: "20px", display: "flex", flexDirection: "row", gap: "100px" }}>
									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Practitioner DOB:</label>
											<Switch
												name="enforcePractitionerDOB"
												onChange={() => handleSwitchChange(setEnforcePractitionerDOB)}
												checked={enforcePractitionerDOB}
											/>
											<Tooltip title="If enabled, DOB will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Practitioner Gender:</label>
											<Switch
												name="enforcePractitionerGender"
												onChange={() => handleSwitchChange(setEnforcePractitionerGender)}
												checked={enforcePractitionerGender}
											/>
											<Tooltip title="If enabled, Gender will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Practitioner Address:</label>
											<Switch
												name="enforcePractitionerAddress"
												onChange={() => handleSwitchChange(setEnforcePractitionerAddress)}
												checked={enforcePractitionerAddress}
											/>
											<Tooltip title="If enabled, Address will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>

									</div>
									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Country:</label>
											<Switch
												name="enforcePractitionerCountry"
												onChange={() => handleSwitchChange(setEnforcePractitionerCountry)}
												checked={enforcePractitionerCountry}
											/>
											<Tooltip title="If enabled, country will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Province:</label>
											<Switch
												name="enforcePractitionerProvince"
												onChange={() => handleSwitchChange(setEnforcePractitionerProvince)}
												checked={enforcePractitionerProvince}
											/>
											<Tooltip title="If enabled, province will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>City:</label>
											<Switch
												name="enforcePractitionerCity"
												onChange={() => handleSwitchChange(setEnforcePractitionerCity)}
												checked={enforcePractitionerCity}
											/>
											<Tooltip title="If enabled, city will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
									</div>

									<div>
										<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
											<label style={{ fontWeight: "bold", fontSize: "18px" }}>Postal Code:</label>
											<Switch
												name="enforcePractitionerPostal"
												onChange={() => handleSwitchChange(setEnforcePractitionerPostal)}
												checked={enforcePractitionerPostal}
											/>
											<Tooltip title="If enabled, postal code will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
												<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
											</Tooltip>
										</div>
									</div>


								</div>
							</div>
						</div>
					)}

					{/* Client Registry Tab */}
					{userRoles?.includes('Super-Admin') && (
						<div style={{ display: selectedTab === "Client Registry" ? 'block' : 'none' }}>
							<div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
								<label style={{ fontWeight: "bold", fontSize: "20px" }}>External Client Registry:</label>
								<div style={{ marginTop: "20px", marginLeft: "20px" }}>
									<div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
										<label style={{ fontSize: "18px" }}>Enable External Client Registry:</label>
										<Switch
											name="ecrEnabled"
											onChange={() => handleSwitchChange(setEcrEnabled)}
											defaultChecked={false}
										/>
										<Tooltip title="If enabled, External Client Registry will be enabled for this organization." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
											<InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
										</Tooltip>
									</div>
								</div>
							</div>
							<div style={{ marginTop: "5px" }}>
								<Row>
									<Col>
										<TextInput
											keyField={"ecrIdentifier"}
											label={"Client Registry Identifier"}
											formik={formik}
											placeholder={"Client Registry Identifier"}
											tooltip={"A unique identifier for the client registry provider"}
										/>
									</Col>
								</Row>

							</div>
						</div>
					)}

					<div className="btn-wrap" style={{ display: "flex", gap: "8px" }}>
						{selectedTab === tabTitles[0] && (
							<Button onClick={() => navigate("/app/manage-organization")} variant="secondary"> {CANCEL}</Button>
						)}

						{selectedTab !== tabTitles[0] && (
							<Button onClick={handlePrevious} variant="secondary"> Previous </Button>
						)}

						{isLastTab ? (
							<Button type="submit" onClick={() => setSubmitAction('save')} isLoading={btnLoading}> Save </Button>
						) : (
							anyFeatureEnabled || selectedTab === tabTitles[0] || selectedTab === tabTitles[1] ? (
								<Button type="submit" onClick={() => { handleNext(); setSubmitAction('saveAndNext'); }} variant="primary">Save & Next</Button>
							) : (
								<Button type="submit" onClick={() => setSubmitAction('save')} isLoading={btnLoading}> Save </Button>
							)
						)}
					</div>
				</form>
			</div>
		</section>
	);
}

export default AddOrganization;